<template>
  <section class="cat">
    <CatTutorial v-if="isTutorialChecked" />
    <PrimeModal v-if="isOpenPrimeModal"
      @closeModal="closePrimeModal()"
      @okModal="okPrimeModal()" />
    <LicenceModal v-if="isOpenLicenceModal"
      @ok="isLicenceModal = false" />

    <NavigationBar />
    <CatHeader/>

    <template v-if="!isParentUser">
      <ActiveAssignment />

      <CatSubtitle :title="'common.sam_recommend_video_lecture'"
        :routeName="'recommend-video-lecture'"
        class="cl-container" />
      <VideoLecture />

      <CatSubtitle :title="'common.sam_recommend_card_lecture'"
        :routeName="'recommend-card-lecture'"
        class="cl-container" />
      <CardLecture />
      
      <CatDomain class="cl-container" />
    </template>

    <template v-if="!isParentUser">
      <CatProficiency />
    </template>

    <template v-if="isParentUser">
      <CatParentView />
    </template>

  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty } from 'lodash';
  import { CLASSTING_PAY_WEB } from '@/config';

  import CatHeader from '../components/CatHeader';
  import ActiveAssignment from '../components/ActiveAssignment';
  import CatDomain from '../components/CatDomain';
  import CatSubtitle from '../components/CatSubtitle';
  import CatProficiency from '../components/CatProficiency';
  import CatTutorial from '../components/CatTutorial';
  import CatParentView from '../components/CatParentView';
  import CardLecture from '../components/CardLecture';
  import VideoLecture from '../components/VideoLecture';
  import PrimeModal from '../components/PrimeModal';

  export default {
    name: 'cat-main',

    data() {
      return {
        isPrimeModal: false,
        isLicenceModal: false,
      };
    },

    components: {
      CatHeader,
      ActiveAssignment,
      CatDomain,
      CatSubtitle,
      CatProficiency,
      CatTutorial,
      CatParentView,
      CardLecture,
      VideoLecture,
      PrimeModal,
    },

    computed: {
      ...mapGetters({
        checkedTutorials: 'checkedTutorials',
        isSupportUser: 'isSupportUser',
        isParentUser: 'isParentUser',
        subjectMap: 'getSubjectMap',
        isSubscriptionUser: 'isSubscriptionUser',
        isPrimeSupportCountry: 'isPrimeSupportCountry',
      }),

      isTutorialChecked() {
        return !this.checkedTutorials.learningIntro;
      },

      isConfirmPrimeNotice() {
        return JSON.parse(this.$localStorage.get('isConfirmPrimeNotice'));
      },

      isOpenPrimeModal() {
        return !this.isSubscriptionUser &&
          !this.isTutorialChecked &&
          this.isPrimeModal &&
          this.isPrimeSupportCountry;
      },

      isOpenLicenceModal() {
        return !this.isSubscriptionUser &&
          !this.isTutorialChecked &&
          this.isLicenceModal &&
          !this.isPrimeSupportCountry;
      },

    },

    methods: {
      ...mapActions([
        'setSelectedLectureSubjectId',
        'setSelectedSubjectId',
        'fetchSubjects',
      ]),

      setMainEventCount(count) {
        return this.$localStorage.set('mainEventCount', count);
      },

      getMainEventCount() {
        return Number(this.$localStorage.get('mainEventCount') || 0);
      },

      showPrime() {
        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(CLASSTING_PAY_WEB);
        }

        return window.open(CLASSTING_PAY_WEB);
      },

      okPrimeModal() {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'modal_learning_tab',
          eventAction: 'click',
        });

        this.isPrmieModal = false;
        this.showPrime();
      },

      closePrimeModal() {
        this.isPrimeModal = false;
        return true;
      },

    },

    beforeMount() {
      if (isEmpty(this.subjectMap)) {
        this.fetchSubjects();
      }

      const initSubjectId = 0;

      this.setSelectedSubjectId(initSubjectId);
      this.setSelectedLectureSubjectId(initSubjectId);

      if (!this.isSubscriptionUser && !this.getMainEventCount()) {
        return this.setMainEventCount(1);
      }

      if (!this.isSubscriptionUser && this.getMainEventCount()) {
        const eventCount = this.getMainEventCount() + 1;
        this.setMainEventCount(eventCount);
      }

      if (!this.isSubscriptionUser && this.getMainEventCount() >= 20) {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'modal_learning_tab',
          eventAction: 'view',
        });
        this.$localStorage.set('mainEventCount', 0);

        if (this.isPrimeSupportCountry) {
          this.isPrimeModal = true;
          return true;
        }

        this.isLicenceModal = true;
        return true;
      }

      return true;
    },

  };
</script>

<style lang="scss" scoped>

  .cat {
    position: relative;
    background-color: #f5f5f5;
  }

</style> 


// WEBPACK FOOTER //
// CatMain.vue?e38580c8